import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  Activity,
  Briefcase,
  Check,
  ChevronDown,
  Download,
  Edit,
  Eye,
  File,
  Mail,
  Map,
  MapPin,
  PhoneCall,
  Server,
  User,
  Users,
} from "react-feather";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_orange.css";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import StatisticsCards from "./StatisticsCards";
import Select from "react-select";
import CommonModal from "../../Components/CommonModal";

import { useNavigate } from "react-router-dom";
import PostApiCall from "../../Api/Api";
import maleIcon from "../../assets/profile/user.jpeg";
import femaleIcon from "../../assets/profile/female-icon1.png";
import { useDispatch, useSelector } from "react-redux";
import { genareteColor } from "../../Helper/GenerateStatusColor";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { ToastContainer, toast } from "react-toastify";
import { delay } from "../../Helper/ToastDelay";
import { NotificationAction } from "../../Store/Actions/NotificationAction";
import { StatusAuditNotification } from "../../Helper/NotificationMsg";
import moment from "moment";
import defaultUser from "../../assets/profile/defaultuser.png";
import { DataTable as DataTables } from "primereact/datatable";
import { Column } from "primereact/column";
import Notiflix from "notiflix";
import { PRIMARY_TEXT_COLOR } from "../../color";
const ManageAuditHistory = () => {
  const [appliedApplicant, setAppliedApplicant] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState([]);
  const [candidateError, setCandidateError] = useState(false);

  const [recruiterRemarkModal, setRecruiterRemarkModal] = useState(false);

  const [filteredData, setFilteredData] = useState([]);

  const [refresh, setRefresh] = useState(false);

  const user = useSelector((state) => state.login);

  const [auditAction, setAuditAction] = useState({
    auditstatus: { value: "Pending", label: "Pending" },
    startdate: "",
    enddate: "",
    remarks: "",
    totalamt: 0,
    payableamt: "",
    salarytype: "",
    additionalamt: "",
    mandays: 1
  });
  const [errors, setErrors] = useState({});

  const validate = () => {
    let newErrors = {};

    if (!auditAction.auditstatus) newErrors.auditstatus = "Audit status is required";
    if (!auditAction.totalamt) newErrors.totalamt = "Total amount is required";
    if (!auditAction.salarytype) newErrors.salarytype = "Salary type is required";
    if (!auditAction.mandays || auditAction.mandays < 1) newErrors.mandays = "Working duration is required";
    if (auditAction.auditstatus.value === 'Rejected') {
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    } else {
      if (!auditAction.payableamt) {
        newErrors.payableamt = "Payable amount is required";
      } else if (Number(auditAction.payableamt) > Number(auditAction.totalamt)) {
        newErrors.payableamt = "Payable amount cannot be more than total amount";
      }
      if (!auditAction.remarks) newErrors.remarks = "Remarks are required";
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    }
  };
  const submitForm = async () => {
    // console.log("disuhudhs", auditAction)
    // return


    let Id;
    let paymentStatus;
    let IsPay;
    if (selectedCandidate.length > 0) {
      Id = selectedCandidate.map((ele) => ele.fld_id).join(",");
      paymentStatus = "Release";
      IsPay = 1;
      let payload = {
        id: Id,
        paymentstatus: paymentStatus,
        jobstartdate: "",
        jobenddate: "",
        auditcompletionstatus: 'Completed',
        totalamount: Number(auditAction?.totalamt) || 0,
        payableamount: Number(auditAction?.payableamt) || 0,
        workremark: auditAction?.remarks || "",
        mandays: auditAction?.mandays || 1,
        additionalamount: Number(auditAction?.additionalamt) || 0,
        isPay: IsPay,
      };

      try {
        Notiflix.Loading.standard();
        const res = await PostApiCall.postRequest(
          payload,
          "UpdateAuditCompletion"
        );
        const json = await res.json();

        if (res.ok) {
          toast.success("Status updated successfully", {
            autoClose: delay,
          });

          setRefresh(true);
          setSelectedCandidate([]);
        } else {
          throw new Error(json.data);
        }
        Notiflix.Loading.remove();
      } catch (error) {
        Notiflix.Loading.remove();

        toast.error(error.message || SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
      }

      setRecruiterRemarkModal(false);
      setAuditAction({
        auditstatus: { value: "Pending", label: "Pending" },
        startdate: "",
        enddate: "",
        remarks: "",
        totalamt: "",
        payableamt: "",
        additionalamt: "",
        mandays: 1
      });
    } else {
      if (validate()) {
        Id = selectedCandidate.fld_id;
        paymentStatus = selectedCandidate?.fld_paymentstatus;
        IsPay = 0;
        let payload = {
          id: Id,
          paymentstatus: paymentStatus,
          jobstartdate: "",
          jobenddate: "",
          auditcompletionstatus: auditAction?.auditstatus?.value,
          totalamount: Number(auditAction?.totalamt) || 0,
          payableamount: Number(auditAction?.payableamt) || 0,
          workremark: auditAction?.remarks || "",
          mandays: auditAction?.mandays || 1,
          additionalamount: Number(auditAction?.additionalamt) || 0,
          isPay: IsPay,
        };

        try {
          Notiflix.Loading.standard();
          const res = await PostApiCall.postRequest(
            payload,
            "UpdateAuditCompletion"
          );
          const json = await res.json();

          if (res.ok) {
            toast.success("Status updated successfully", {
              autoClose: delay,
            });

            setRefresh(true);
            setSelectedCandidate([]);
          } else {
            throw new Error(json.data);
          }
          Notiflix.Loading.remove();
        } catch (error) {
          Notiflix.Loading.remove();

          toast.error(error.message || SomethingWrong, {
            autoClose: delay,
            toastId: 1,
          });
        }

        setRecruiterRemarkModal(false);
        setAuditAction({
          auditstatus: { value: "Pending", label: "Pending" },
          startdate: "",
          enddate: "",
          remarks: "",
          totalamt: "",
          payableamt: "",
          additionalamt: "",
          mandays: 1
        });
      }

    }
  };
  const calculateValue = (value) => {
    return ( Number(value.mandays) * Number(value.payableamt)) + Number(value.additionalamt)
  }
  const GenerateInvoice = async () => {
    let Id;
    let totalamt;
    let userid;
    if (Array.isArray(selectedCandidate) && selectedCandidate.length > 0) {
      Id = selectedCandidate.map((ele) => ele.fld_id).join(",");
      totalamt = selectedCandidate.reduce(
        (acc, ele) =>
          acc + (Number(ele.fld_additionalamount)+Number(ele.fld_payableamount) * Number(ele.fld_mandays)),
        0
      );
      userid = selectedCandidate[0].fld_userid;
    } else if (selectedCandidate) {
      Id = selectedCandidate.fld_id;
      totalamt =(Number(selectedCandidate.fld_additionalamount)+Number(selectedCandidate.fld_payableamount) * Number(selectedCandidate.fld_mandays))
      userid = selectedCandidate.fld_userid;
    }

    let payload = {
      userid: userid,
      auditid: Id,
      invoicetype: "work",
      totalamount: totalamt || 0,
    };

    // console.log(payload, selectedCandidate, 'payload')
    // return

    try {
      Notiflix.Loading.standard();

      const res = await PostApiCall.postRequest(payload, "JobGenerateInvoice");
      const json = await res.json();

      if (res.ok) {
        toast.success(json.data, {
          autoClose: delay,
        });

        setRefresh(true);
        setSelectedCandidate([]);
      } else {
        throw new Error(json.data);
      }
      Notiflix.Loading.remove();
    } catch (error) {
      Notiflix.Loading.remove();
      toast.error(error.message || SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    }

    setRecruiterRemarkModal(false);
  };

  useEffect(() => {
    (async () => {
      Notiflix.Loading.standard();
      try {
        const res = await PostApiCall.postRequest(
          { usertype: user?.fld_usertype },
          "GetAuditCompletion"
        );
        const { data } = await res.json();

        if (res.status == 200) {
          setAppliedApplicant(data);
          setFilteredData(data);

          setRefresh(false);
        } else {
          throw new Error(data.message);
        }
        Notiflix.Loading.remove();
      } catch (error) {
        toast.error(error.message || SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
        Notiflix.Loading.remove();
      }
    })();
  }, [refresh]);

  const isRowDisabled = (rowData) => {
    return rowData.fld_invoiceno && rowData.fld_invoiceno !== ""; // Example: Disable if status is "Completed"
  };
  const isRowDisabledStatus = (rowData) => {


    return rowData?.fld_auditcompletionstatus === "Completed" && rowData?.fld_paymentstatus === "Release";
  };



  return (
    <div className="container-fluid">
      <ToastContainer />
      <div className="mb-2">
        {/* <Row className="gap-4">
          <Col sm="12">
            <div className="mb-3 text-dark">Job Applicants Status</div>
          </Col>
          <Col lg="3" sm="6">
            <StatisticsCards
              iconRight
              iconBg="primary"
              icon={<Server className="primary " size={20} />}
              stat={appliedApplicant?.length}
              statTitle="Total"
            />
          </Col>
          <Col lg="3" sm="6">
            <StatisticsCards
              iconRight
              iconBg="primary"
              icon={<Activity className="primary" size={20} />}
              stat={getStatusCounts().reject}
              statTitle="Rejected"
            />
          </Col>
          <Col lg="3" sm="6">
            <StatisticsCards
              iconRight
              iconBg="primary"
              icon={<Check className="primary" size={20} />}
              stat={getStatusCounts().approve}
              statTitle="Approved"
            />
          </Col>
          <Col lg="3" sm="6">
            <StatisticsCards
              iconRight
              iconBg="primary"
              icon={<Users className="primary" size={20} />}
              stat={getStatusCounts().pending}
              statTitle="Pending"
            />
          </Col>
        </Row> */}
      </div>
      <div
        className="p-2 mt-4"
      // style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)", border: "none" }}
      >
        {/* <Row className="filter-actions my-2 justify-content-between">
          <Col sx="12" md="3">
            <Input
              style={{
                border: "#cccccc solid 1px",
                height: "38px",
                borderRadius: "5px",
              }}
              className="mr-1 pt-0 shadow-sm"
              type="text"
              placeholder="search..."
              onChange={(e) => updateSearchQuery(e.target.value)}
              value={searchVal}
            />
          </Col>
          <Col sm="12" md="3" style={{}}>
            <div className="dropdown actions-dropdown" style={{ zIndex: 20 }}>
              <Select
                className="React"
                classNamePrefix="select "
                placeholder="Filter by"
                name="color"
                options={[
                  { value: "All", label: "All" },
                  { value: "Active", label: "Active" },
                  { value: "Inactive", label: "InActive" },
                ]}
                onChange={(selectedOption) => updateFilter(selectedOption)}
                value={selectedFilter}
              />
            </div>
          </Col>
        </Row> */}
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
          <h5 style={{ color: PRIMARY_TEXT_COLOR }}>Audit History</h5>
          {user?.fld_usertype === "Staff" || user?.fld_isadmin === 1 ? (
            <div className="text-right mb-3 ">
              <a
                className="mt-0 btns text-white mr-2"
                style={{
                  textTransform: "capitalize",
                  opacity: `${selectedCandidate.length > 0 ? 1 : 0.2}`,
                }}
                onClick={() => {
                  if (selectedCandidate.length > 0) {
                    Notiflix.Confirm.show(
                      "Payment Release!",
                      "Are you sure you want to release the payment for the selected Auditor?",
                      "Yes",
                      "No",
                      () => {
                        // If user clicks "Yes", submit the form
                        submitForm();
                      },
                      () => {
                        // If user clicks "No", do nothing or handle accordingly
                      }
                    );
                  }
                }}
              >
                Payment Approval
              </a>
              {/* <a
                className="mt-0 btns text-white"
                style={{
                  textTransform: "capitalize",
                  opacity: `${selectedCandidate.length > 0 ? 1 : 0.2}`,
                }}
                onClick={() => {
                  if (selectedCandidate.length > 0) {
                    Notiflix.Confirm.show(
                      "Payment Release!",
                      "Are you sure you want to release the payment for the selected Auditor?",
                      "Yes",
                      "No",
                      () => {
                        // If user clicks "Yes", submit the form
                        submitForm();
                      },
                      () => {
                        // If user clicks "No", do nothing or handle accordingly
                      }
                    );
                  }
                }}
              >
                Payment Approval
              </a> */}
            </div>
          ) : (
            <div className="text-right mb-3">
              <a
                className="mt-0 btns text-white"
                style={{
                  textTransform: "capitalize",
                  opacity: `${selectedCandidate.length > 0 ? 1 : 0.2}`,
                }}
                onClick={() => {
                  if (selectedCandidate.length > 0) {
                    GenerateInvoice();
                  }
                }}
              >
                Generate Invoice
              </a>
            </div>
          )}
        </div>

        <DataTables
          highlightOnHover={true}
          value={filteredData}
          selectionMode={"checkbox"}
          selection={selectedCandidate}
          onSelectionChange={(e) => {
            const newSelection = e.value.filter((row) => !isRowDisabled(row));
            if (user?.fld_usertype === 'Seeker' || user?.fld_usertype === 'Auditor') {
              e.value.map(ele => {
                if (ele.fld_paymentstatus === "Pending") {
                  Notiflix.Notify.warning('Invoice generation is allowed only after the payment has been approved.')
                }
              })
            }
            // if(newSelection.length > 0){
            // }
            const status = e.value.filter((row) => isRowDisabledStatus(row));

            setCandidateError(false);
            setSelectedCandidate((user?.fld_usertype === "Staff" || user?.fld_isadmin === 1) ? newSelection : status);
          }}
          dataKey="fld_id"
          // tableStyle={{ minWidth: "80rem" }}
          paginator={true}
          rows={5}
          style={{ fontSize: "13px" }}
          rowClassName={(rowData) =>
            isRowDisabled(rowData) ? "disabled-row" : ""
          }
        >
          <Column selectionMode="multiple" style={{ padding: "10px" }}></Column>

          <Column
            sortable={true}
            field="fld_id"
            header="Job Id"
            headerStyle={{
              width: "100px",
              minWidth: "100px",
              fontSize: "13px",
            }}
            bodyStyle={{ minWidth: "100px", fontSize: "13px" }}
          ></Column>
          <Column
            sortable={true}
            field="fld_auditcompletionstatus"
            header="Audit Status"
            headerStyle={{
              width: "150px",
              minWidth: "180px",
              fontSize: "13px",
            }}
            bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
            body={(rowData) => (
              <div className="text-truncate" style={{ maxWidth: "200px" }}>
                <span
                  className={`${genareteColor(
                    rowData.fld_auditcompletionstatus == ""
                      ? "Pending"
                      : rowData.fld_auditcompletionstatus
                  )} font-size-3 rounded-3 px-2`}
                >
                  {rowData.fld_auditcompletionstatus == ""
                    ? "Pending"
                    : rowData.fld_auditcompletionstatus}
                </span>
                {/* {rowData.fld_auditstatus} */}
              </div>
            )}
          />

          <Column
            sortable={true}
            field="fld_paymentstatus"
            header="Payment Status"
            headerStyle={{
              width: "150px",
              minWidth: "180px",
              fontSize: "13px",
            }}
            bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
            body={(rowData) => (
              <>
                <div className="text-truncate" style={{ maxWidth: "200px" }}>
                  <span
                    className={`${genareteColor(
                      rowData.fld_paymentstatus
                    )} font-size-3 rounded-3 px-2`}
                  >
                    {rowData.fld_paymentstatus === "Release"
                      ? "Approved"
                      : rowData.fld_paymentstatus}
                  </span>

                  {/* {rowData.fld_auditstatus} */}
                </div>
              </>
            )}
          />
          <Column
            sortable={true}
            field="fld_title"
            header="Job Title"
            headerStyle={{
              width: "150px",
              minWidth: "180px",
              fontSize: "13px",
            }}
            bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
          ></Column>
          <Column
            sortable={true}
            field="fld_name"
            header="Auditor Name"
            headerStyle={{
              width: "150px",
              minWidth: "180px",
              fontSize: "13px",
            }}
            bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
            body={(rowData) => (
              <>
                <div className="text-truncate" style={{ maxWidth: "200px", textTransform: "capitalize" }}>
                  {rowData.fld_name}
                </div>
              </>
            )}
          ></Column>
          <Column
            sortable={true}
            field="fld_mandays"
            header="Man-days"
            headerStyle={{
              width: "150px",
              minWidth: "180px",
              fontSize: "13px",
            }}
            bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
          ></Column>



          {/* <Column
            sortable={true}
            field="fld_totalamount"
            header="Payable Amount"
            headerStyle={{
              width: "150px",
              minWidth: "180px",
              fontSize: "13px",
            }}
            body={(rowDate) => {
              rowDate?.fld_totalamount != 0 && (
                <div> Rs {rowDate?.fld_totalamount}</div>
              );
            }}
            bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
          ></Column> */}
          <Column
            sortable={true}
            field="fld_totalamount"
            header="Audit Amount"
            headerStyle={{
              width: "150px",
              minWidth: "180px",
              fontSize: "13px",
            }}
            body={(rowData) => (

              <>
                {
                  rowData?.fld_finalprice &&
                  <span>
                    {" "}
                    {rowData?.fld_currency} {rowData?.fld_payableamount} /{" "}
                    {rowData.fld_finalsalarytype}
                  </span>
                }

              </>
            )}
            bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
          ></Column>
          <Column
            sortable={true}
            field="fld_additionalamount"
            header="Payable Amount"
            headerStyle={{
              width: "150px",
              minWidth: "180px",
              fontSize: "13px",

            }}
            body={(rowData) => (
              <span>
                INR {rowData?.fld_payableamount * rowData?.fld_mandays + rowData?.fld_additionalamount}
              </span>
            )}
            bodyStyle={{ minWidth: "150px", fontSize: "13px" }}
          ></Column>
          {(user?.fld_usertype === "Staff" || user?.fld_isadmin === 1) && (
            <Column
              body={(rowData) => (
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setAuditAction((prev) => ({
                      ...prev,
                      auditstatus: {
                        label: rowData?.fld_auditcompletionstatus,
                        value: rowData?.fld_auditcompletionstatus,
                      },
                      additionalamt: rowData?.fld_additionalamount,
                      totalamt: rowData?.fld_finalprice,
                      salarytype: rowData?.fld_finalsalarytype,
                      remarks: rowData?.fld_workremark,
                      payableamt: rowData?.fld_payableamount,
                    }));

                    setSelectedCandidate(rowData);
                    setRecruiterRemarkModal(true);
                  }}
                >
                  <Edit size={15} />
                </div>
              )}
              header="Action"
              style={{ width: "150px", cursor: "pointer" }}
            ></Column>
          )}
        </DataTables>
      </div>

      {recruiterRemarkModal === true && (
        <CommonModal
          isOpen={recruiterRemarkModal}
          toggle={() => setRecruiterRemarkModal(false)}
          heading={"Audit Action"}
          contentBody={
            <Row style={{ marginTop: "0px", zIndex: "50" }}>
              <Col sx="12" md="12">
                <Label for="auditstatus">Audit Completion Status <span className="mandatory">*</span></Label>

                <Select
                  placeholder="Select"
                  name="auditstatus"
                  options={[
                    { value: "Pending", label: "Pending" },
                    { value: "Reviewed", label: "Reviewed" },
                    { value: "Completed", label: "Completed" },
                    { value: "Rejected", label: "Rejected" },
                  ]}
                  onChange={(selectedOption) => {
                    setAuditAction((pre) => ({ ...pre, auditstatus: selectedOption }));
                  }}
                  value={auditAction.auditstatus}
                />
                {errors.auditstatus && <p style={{ color: "red" }}>{errors.auditstatus}</p>}
              </Col>

              <Col sx="12" md="3" className="my-2">
                <Label for="totalamt">Currency <span className="mandatory">*</span></Label>
                <Input type="text" disabled value={'INR'} />
              </Col>

              <Col sx="12" md="5" className="my-2">
                <Label for="totalamt">Final Amount <span className="mandatory">*</span></Label>
                <Input
                  type="number"
                  placeholder="Amount"
                  onChange={(e) => setAuditAction((pre) => ({ ...pre, totalamt: e.target.value }))}
                  disabled
                  value={auditAction.totalamt}
                />
                {errors.totalamt && <p style={{ color: "red" }}>{errors.totalamt}</p>}
              </Col>

              <Col sx="12" md="4" className="my-2">
                <Label for="salarytype">Salary Type <span className="mandatory">*</span></Label>
                <Input
                  type="text"
                  placeholder="Salary type"
                  disabled
                  value={auditAction.salarytype}
                />
                {errors.salarytype && <p style={{ color: "red" }}>{errors.salarytype}</p>}
              </Col>

              <Col sx="12" md="6" className="my-2">
                <Label for="mandays">Working Duration <span className="mandatory">*</span></Label>
                <Input
                  type="number"
                  placeholder="mandays"
                  onChange={(e) => setAuditAction((pre) => ({ ...pre, mandays: e.target.value }))}
                  min={1}
                  value={auditAction.mandays}
                />
                {errors.mandays && <p style={{ color: "red" }}>{errors.mandays}</p>}
              </Col>

              <Col sx="12" md="6" className="my-2">
                <Label for="payableamt">Payable Amount <span className="mandatory">*</span></Label>
                <Input
                  type="number"
                  placeholder="Amount"
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    if (value > auditAction.totalamt) {
                      alert("Payable amount cannot be more than the total amount.");
                      return;
                    }
                    setAuditAction((pre) => ({ ...pre, payableamt: value }));
                  }}
                  value={auditAction.payableamt}
                />
                {errors.payableamt && <p style={{ color: "red" }}>{errors.payableamt}</p>}
              </Col>
              <Col sx="12" md="12" className=" my-2">
                <Label for="nameVertical">
                  Additional Amount

                </Label>
                <Input
                  type="number"
                  placeholder="Additional Amount"
                  onChange={(e) =>
                    setAuditAction((pre) => ({
                      ...pre,
                      additionalamt: e.target.value,
                    }))
                  }
                  value={auditAction.additionalamt}
                />
              </Col>
              {
                auditAction.payableamt != 0 &&
                <Col sx="12" className="d-flex justify-content-center " style={{ border: '1 dotted gray' }}>

                  <div class="calculation">
                    <span>{auditAction.mandays} / {auditAction.salarytype}</span>
                    <span class="operator">× {auditAction.payableamt} +</span>
                    <span>{auditAction.additionalamt || 0}</span>
                    <span class="equals">=</span>
                    <span>{calculateValue(auditAction)}</span>
                  </div>
                </Col>

              }

              <Col sx="12" md="12" className="my-2">
                <Label for="remarks">Remarks <span className="mandatory">*</span></Label>
                <Input
                  type="textarea"
                  placeholder="Message ..."
                  value={auditAction.remarks}
                  style={{ height: "100px", paddingLeft: "10px" }}
                  onChange={(e) => setAuditAction((pre) => ({ ...pre, remarks: e.target.value }))}
                />
                {errors.remarks && <p style={{ color: "red" }}>{errors.remarks}</p>}
              </Col>


            </Row>
          }
          onConfirm={submitForm}
          confirmText={"submit"}
          // acceptText={<Check size={15} />}
          // rejectText={<X size={15} />}
          cancelText={"Cancel"}
          onCancel={() => setRecruiterRemarkModal(false)}
        />
      )}
    </div>
  );
};

export default ManageAuditHistory;
